import { Error } from '../../types/error'
import {
	FluxStandardAction,
	FluxStandardFailureAction,
} from '../../types/fluxStandardAction'

export type DeleteSmartCheckSession = FluxStandardAction<
	'smartCheckSession/delete',
	undefined
>
export type DeleteSmartCheckSessionSuccess = FluxStandardAction<
	'smartCheckSession/deleteSuccess',
	undefined
>
export type DeleteSmartCheckSessionFailure =
	FluxStandardFailureAction<'smartCheckSession/deleteFailure'>

export type SmartCheckSessionDeletionAction =
	| DeleteSmartCheckSession
	| DeleteSmartCheckSessionSuccess
	| DeleteSmartCheckSessionFailure

export function deleteSmartCheckSession(): DeleteSmartCheckSession {
	return {
		type: 'smartCheckSession/delete',
		payload: undefined,
	}
}

export function deleteSmartCheckSessionSuccess(): DeleteSmartCheckSessionSuccess {
	return {
		type: 'smartCheckSession/deleteSuccess',
		payload: undefined,
	}
}

export function deleteSmartCheckSessionFailure(
	error: Error,
): DeleteSmartCheckSessionFailure {
	return {
		type: 'smartCheckSession/deleteFailure',
		payload: error,
		error: true,
	}
}
